import * as FileSaver from "file-saver";
import ExportExcel from "../components/Pages/Home/ExportExcel";
import { normalizeIssueReport } from "../constants/issueReportUtils";

export async function exportStructuredBomExcel({
  user,
  bomId,
  fileName,
  structuredBomlines,
  issueReport,
  columns,
  freightTotal = 0,
  tariffTotal = 0,
  exportLocally = true,
  bomChecklists = [],
}) {
  if (!structuredBomlines?.length) {
    throw new Error("No BOM lines available to export.");
  }

  await ExportExcel(
    user,
    {
      bomId,
      bomlines: structuredBomlines,
      excelData: structuredBomlines,
      issue_report: issueReport,
      invalidQuantityColumns: [],
      fileName,
    },
    [],
    columns || [],
    exportLocally,
    bomChecklists,
    {
      freightTotal,
      tariffTotal,
      currency: "$",
    },
  );
}

export async function downloadOriginalAndResultBomFiles({
  user,
  getFile,
  filePath,
  fileName,
  resultFilePath,
  exportResult = null,
}) {
  const fileBlob = filePath ? await getFile(user.token, filePath) : null;
  if (fileBlob) {
    FileSaver.saveAs(fileBlob, `${fileName}.xlsx`);
  }

  if (exportResult) {
    await exportStructuredBomExcel(exportResult);
    return;
  }

  if (resultFilePath) {
    const resultFileBlob = await getFile(user.token, resultFilePath);
    if (resultFileBlob) {
      FileSaver.saveAs(resultFileBlob, `Result-${fileName}.xlsx`);
    }
  }
}

export function buildHistoryExportPayload({
  user,
  bomRow,
  bomDetails,
  structuredBomlines,
  columns,
  issueReport,
  freightTotal,
  tariffTotal,
  exportLocally = true,
}) {
  return {
    user,
    bomId: bomRow.id,
    fileName: bomRow.file_name || bomDetails?.data?.file_name,
    structuredBomlines,
    issueReport: normalizeIssueReport(
      issueReport || bomDetails?.data?.issue_report,
    ),
    columns,
    freightTotal,
    tariffTotal,
    exportLocally,
  };
}
